import { Component, OnDestroy } from '@angular/core';
import { SettingsService } from '../settings.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/user';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { ChangeOrganisationModal } from '../components/change-organisation/change-organisation.modal';
import { IdsForSettingsService, OrganisationInfoModel } from '../ids-for-settings.service';

@Component({
  templateUrl: './organisation.layout.html'
})
export class OrganisationLayout implements OnDestroy {

  selectedOrganisationName: string = "";
  orgNameSubscription!: Subscription;
  user!: User;
  modalRef!: NgbModalRef;


  constructor(private router: Router, private modalService: NgbModal, private idsForSettingsService: IdsForSettingsService, private settingsService: SettingsService, private route: ActivatedRoute, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
    this.user = this.settingsService.user;
    // subscribe so we can update the name
    this.orgNameSubscription = this.idsForSettingsService.selectedOrganisationName$.subscribe(organisationName => {
      this.selectedOrganisationName = organisationName;
    });


  }

  ngOnInit() {
    let organisationId = this.route.snapshot.paramMap.get('organisationId');
    if (organisationId == null || organisationId == "") {
      return;
    }
    this.identityOrganisationApiClient.getOrganisation(organisationId).subscribe(organisationData => {
      this.idsForSettingsService.setSelectedOrganisation(new OrganisationInfoModel(organisationData?.organisation?.guid, organisationData?.organisation?.name));
    });
    if(this.user.isOrganisationAdmin || this.user.isWhitelabelAdmin || this.user.isSystemAdmin) {
      this.settingsService.getOrganisation(organisationId, this.user);
    }
  }

  openChangeOrganisationModal() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    this.modalRef = this.modalService.open(ChangeOrganisationModal, ngbModalOptions);
    this.modalRef.componentInstance.organisationInfo.subscribe((organisationInfo: OrganisationInfoModel) => {
      if (!organisationInfo) return;

      this.selectedOrganisationName = organisationInfo.organisationName;
      this.idsForSettingsService.setSelectedOrganisation(organisationInfo); 

      let userId = this.route.firstChild?.firstChild?.snapshot?.paramMap?.get('userId');
      if(userId != null && userId != ""){
        this.router.navigate(['/settings', 'organisation', organisationInfo.organisationGuid, 'users'], { relativeTo: this.route });
      }
    });
  }

  ngOnDestroy() {
    this.orgNameSubscription.unsubscribe();
  }
}
